import { Stack } from '@mui/material';
import * as React from 'react';
import Banner from './Contents/Banner';
import NavBar from './NavBar';
import Projects from './Contents/Projects';
import SignInView from '../SignUp/SignInView';
import LibraryProjects from './Contents/LibraryProjects';
import { dataCollection } from '../../config/firebase';
import { getDocs } from 'firebase/firestore';
import { MainData } from '../../Data/Models/MainData';
import Footer from '../Footer';

function Home() {

  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState<MainData[]>([{
    banner : "",
    subBanner : "",
    title : ""
  }])

  React.useEffect(() => {
    const fetchData = async () => {
        const querySnapshot = await getDocs(dataCollection);
        const myCollectionData = querySnapshot.docs.map((doc) => doc.data());
        setData(myCollectionData as MainData[])
    };

    fetchData();
}, []);
  
  return (
    <>
      <NavBar title={data[0].title} add={() => {
        setOpen(true)
      }} />

      <Stack spacing={2} justifyContent="space-between">
        <Banner banner={data[0].banner} subBanner={data[0].subBanner}/>
        <LibraryProjects />
        <Projects />
        <Footer/>
      </Stack>
      <SignInView toggle={[open, setOpen]}></SignInView>
    </>
  );
}

export default Home;
